<template>
  <div
    class="file-input"
    :class="{
      'file-input--uploaded': existingImg,
      'file-input--focus': isFocused,
    }"
  >
    <div
      class="file-input__area ta-center p-md"
      v-if="!existingImg"
      style="margin-top: 0.33em;"
    >
      <input
        type="file"
        :multiple="multiple"
        :name="fieldName"
        :disabled="isDisabled"
        @change="changeFiles($event.target)"
        :accept="accept"
      />
      <label for="file">
        <i class="fc-light fa-2x fa fa-picture-o mb-xxs" aria-hidden="true"></i>
        <p class="fc-medium fs-sm">
          <span v-if="!fileName">{{ zoneText }}</span
          ><span v-else>{{ fileName }}</span>
        </p>
      </label>
    </div>
    <div class="file-input__area ta-center p-md" v-else>
      <img
        class="file-input__image"
        :class="{ 'is-visible': existingImg }"
        :src="existingImg"
        alt=""
      />
      <Button
        bType="error"
        bSize="slim"
        :class="{ 'is-visible': existingImg }"
        class="mt-3"
        type="button"
        name="deleteLogo"
        v-on:button-click="deleteFile()"
      >
        Delete Image
      </Button>
    </div>
    <p class="file-input__help fc-medium fs-sm mt-xxs" v-if="!existingImg">
      {{ helpText }}
    </p>
    <p class="file-input__help text-red-medium fs-sm mt-xs" v-if="error">
      {{ error }}
    </p>
  </div>
</template>

<script>
import Button from '@/components/DesignSystem/Button';

export default {
  name: 'fileUploadZone',
  props: {
    accept: {
      type: String,
      default: '.png',
    },
    field: {
      type: String,
      default: 'image',
    },
    existingImg: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    zoneText: {
      type: String,
      default: 'Click or drag here to upload',
    },

    // In bytes
    maxSize: {
      type: Number,
      default: 4000000,
    },
  },
  components: {
    Button,
  },
  data() {
    return {
      isFocused: false,
      fileCount: 0,
      fileName: undefined,
      error: false,
    };
  },
  methods: {
    changeFiles(target) {
      this.isFocused = true;
      this.fileCount = target.files.length;

      if (target.files[0].size >= this.maxSize) {
        this.error = `Please upload a file less than ${
          this.maxSize.toString()[0]
        }MB`;
        return this.deleteFile();
      }

      if (target.files[0].type === 'image/svg+xml') {
        this.error =
          'The file type you are attempting to upload is not supported.';
        return this.deleteFile();
      }

      this.error = false;

      if (this.fileCount) {
        this.fileName = Array.from(target.files)
          .map(file => file.name)
          .join(', ');
      }
      this.$emit('update-image', { file: target.files, field: this.field });
    },
    deleteFile() {
      this.fileCount = 0;
      this.fileName = '';
      this.isFocused = false;
      this.$emit('update-image', { file: undefined, field: this.field });
    },
  },
  watch: {
    existingImg() {
      if (this.existingImg) {
        this.isFocused = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-input__image {
  max-height: 170px;
}
</style>
